import { Navigate } from "react-router-dom";
import * as general from "../libs/general";
import { canViewChildFeature } from "../libs/childUserPermission";

const ChildFeatureRoute = ({ feature, children }) => {
  const config = general.getLocalStorage("user_config");
  if (!canViewChildFeature(config, feature)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ChildFeatureRoute;
